<template>
  <page>
    <div class="sb-container">
      <el-tooltip placement="bottom-end" :content="tooltipContent">
        <search-box
          :placeholder="sbPlaceholder"
          :input="input"
          :onSearch="onSearch"
        />
      </el-tooltip>
      <el-button
        type="text"
        icon="el-icon-back"
        @click="goBack"
        v-if="showBackButton"
        >back</el-button
      >
    </div>
    <div class="results-container">
      <div v-if="results" v-loading="loading.csResults">
        <results :data="results || {}" />
      </div>
      <div v-else>
        <router-view />
      </div>
    </div>
  </page>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Page from "@/components/layout/Page";
import SearchBox from "@/components/SearchBox";
import Results from "./SearchResults";

export default {
  data() {
    return {
      tooltipContent:
        "Search by id, email, team slug, project short id, playground id or domains.",
      sbPlaceholder: "Look for users, teams, projects, playgrounds or subscriptions...",
      showBackButton: false,
      input: { value: "" },
      results: null,
    };
  },
  components: {
    Page,
    SearchBox,
    Results,
  },
  mounted() {
    this.onRouteChange();
    this.onRouteParamsChange();
  },
  computed: mapGetters(["user", "team", "project", "loading"]),
  methods: {
    ...mapMutations(["setLoading", "unsetLoading"]),
    goBack() {
      this.$router.go(-1);
    },
    async onSearch(query) {
      if (this.loading.csResults) return;
      try {
        this.setLoading("csResults");
        const q = query.trim();
        const params = { q };
        const {
          data: { type, result },
        } = await this.$api.get("/cs/search", { params });
        const id = result?.email || result?.id;
        const isZipResult = type === "zip_generation";

        if (id && !isZipResult) {
          this.$router.push({ path: `/customers/${type}/${id}` }, () => {});
        } else {
          this.results = isZipResult ? { playgrounds: [result] } : result;
          this.$router.push({ path: `/customers/${q}` }, () => {});
        }
      } catch (e) {
        this.$notify.error({
          title: "Uh oh! This search failed!",
          message: e.message,
        });
      } finally {
        this.unsetLoading("csResults");
      }
    },
    onRouteChange(data) {
      const { name, params } = data || this.$route;
      if (name === "Customers" && params.query) this.onSearch(params.query);
      else this.results = null;
    },
    onRouteParamsChange(data) {
      const { query } = data || this.$route.params;
      this.input.value = query;
      this.showBackButton = !!query;
    },
  },
  watch: {
    "$route.params"(newParams) {
      this.onRouteParamsChange(newParams);
    },
    $route(newRoute) {
      this.onRouteChange(newRoute);
    },
  },
};
</script>

<style scoped>
.sb-container {
  margin: 20px auto;
  max-width: 700px;
}

.results-container {
  max-width: 1000px;
  margin: 0 auto;
}
</style>
